import { PropertyHelper } from '@/helpers/property.helper';
import { AlertService } from '@/services/alert.service';
import { NotificationCheckService } from '@/services/notification-check.service';
import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Document, DocumentIdentifier, DropBoxDocument, RealProperty, VaultService } from '@eemo/api-client';

import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface DropBoxValidateDialogData {
  doc: DropBoxDocument;
  prop: RealProperty;
}

@Component({
  selector: 'app-dropbox-validate-dialog',
  templateUrl: './dropbox-validate-dialog.component.html',
  styleUrls: ['./dropbox-validate-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    NgIf,
    MatButtonModule
  ]
})
export class DropboxValidateDialogComponent implements OnInit {
  docForm: UntypedFormGroup;
  formSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DropBoxValidateDialogData,
    private vaultService: VaultService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private notificationCheckService: NotificationCheckService,
    public dialogRef: MatDialogRef<DropboxValidateDialogComponent>,
    public propHelper: PropertyHelper
  ) {}

  f(field: string): AbstractControl {
    return this.docForm.get(field);
  }

  ngOnInit() {
    this.docForm = this.fb.group({
      category: ['', [Validators.required]],
      type: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.docForm.valid) {
      this.formSubmitting = true;

      const docName = this.data.doc.name.length > 50 ? this.data.doc.name.substring(0, 49) : this.data.doc.name;

      const validateDoc: Document = {
        name: docName,
        identifier: DocumentIdentifier.NONE,
        category: this.f('category').value,
        type: this.f('type').value
      };
      this.vaultService.validateDropBoxDocument(this.data.doc.uid, validateDoc).subscribe((result) => {
        this.alertService.success('Document validé et disponible dans le coffre du bien.');
        this.notificationCheckService.decreaseDropboxDoc(this.data.prop);
        this.dialogRef.close(true);
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
